import React, {Fragment, useState, useEffect} from 'react';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import {Box, Grid, Link, TextField, Typography} from '@material-ui/core';
import Switch from '@material-ui/core/Switch';
import Card from '../../../components/Card/Card.jsx';
import CardBody from '../../../components/Card/CardBody.jsx';
import CardHeader from '../../../components/Card/CardHeader';
import Button from '../../../components/CustomButtons/Button.jsx';
import {API, Storage} from 'aws-amplify';

const TransferDocumentsView = ({classes, transferDocumentData, transferDocumentId}) => {
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);

  const [transferId, setTransferId] = useState('');
  const [description, setDescription] = useState('');
  const [documentId, setDocumentId] = useState('');
  const [attachments, setAttachments] = useState([]);
  const [has_fww_portal_bucket, setHas_fww_portal_bucket] = useState(false);

  const [documentDownloadUrl, setDocumentDownloadUrl] = useState(null);
  const [isForbidden, setIsForbidden] = useState(false);

  const handleSave = () => {
    setLoading(true);

    const transferDocumentData = {
      transferId,
      description
    };

    API.put('transfer-documents', `/id/${transferDocumentId}`, {body: transferDocumentData})
      .then(response => {
        console.log(response);
      })
      .catch(error => {
        console.log(error);
        API.put('transfer-documents', `/id/${transferDocumentId}`, {body: transferDocumentData})
          .then(response => {
            console.log(response);
          })
          .catch(error => {
            console.log(error);
          });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const sanitizeKey = key => {
    if (!key || typeof key !== 'string') return key;
    return key.replace(/^public\//, '');
  };

  const getUrl = async fileKey => {
    return await Storage.get(fileKey);
  };

  const AttachmentLink = ({item}) => {
    const [url, setUrl] = useState(null);

    useEffect(() => {
      Storage.get(sanitizeKey(item), {expires: 3600}).then(setUrl);
    }, [item]);

    if (!url) return <span>Loading...</span>;

    return (
      <a href={url} target="_blank" rel="noopener noreferrer">
        {item.split('/').pop()}
      </a>
    );
  };

  useEffect(() => {
    if (!transferDocumentData) {
      return;
    }

    setDocumentDownloadUrl(null);
    setIsForbidden(false);

    const checkForbidden = async key => {
      if (!key || typeof key !== 'string' || !key.trim()) return false;
      try {
        await Storage.get(sanitizeKey(key));
        return false;
      } catch (e) {
        return true;
      }
    };

    const validateAccess = async () => {
      let forbidden = false;
      if (transferDocumentData.file_ref) {
        forbidden = await checkForbidden(transferDocumentData.file_ref);
      } else if (transferDocumentData.file_refs && transferDocumentData.file_refs.length > 0) {
        forbidden = await checkForbidden(transferDocumentData.file_refs[0]);
      }

      setIsForbidden(forbidden);

      if (!forbidden && transferDocumentData.file_ref) {
        getUrl(sanitizeKey(transferDocumentData.file_ref))
          .then(response => {
            setDocumentDownloadUrl(response);
          })
          .catch(err => {
            console.log(err.message || 'error');
          });
      }
    };

    validateAccess();

    setHas_fww_portal_bucket(transferDocumentData.has_fww_portal_bucket);
    setTransferId(transferDocumentData.transferId);
    setDescription(transferDocumentData.description);
    setDocumentId(transferDocumentData.documentId);
    if (transferDocumentData.attachments != null) {
      const files = transferDocumentData.file_refs;
      setAttachments(files);
      if (transferDocumentData.file_refs != null && transferDocumentData.file_refs.length > 0) {
        setTimeout(() => setEditMode(true), 3000);
      }
    }
  }, [transferDocumentData]);

  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12} lg={3}>
          <Card>
            <CardHeader color='rose' icon>
              <div className={classes.flexEnd}>
                <h4 className={classes.cardIconTitle}>{editMode ? 'Edit Record: ' : 'View Record: '}</h4>
                <React.Fragment>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={editMode}
                        onChange={() => setEditMode(prevState => !prevState)}
                        value='edit_mode'
                        classes={{
                          switchBase: classes.switchBase,
                          checked: classes.switchChecked
                        }}
                      />
                    }
                    classes={{
                      label: classes.label
                    }}
                    label={editMode ? 'Edit Mode' : 'Read Only'}
                  />
                </React.Fragment>
              </div>
            </CardHeader>
            <CardBody>
              <Box className={classes.editFields}>
                {documentId && (
                  <Typography color={editMode ? 'textPrimary' : 'textSecondary'}>Document ID: {documentId}</Typography>
                )}

                <TextField
                  disabled={!editMode}
                  fullWidth
                  label='Transfer Id'
                  value={transferId}
                  onChange={e => setTransferId(e.target.value)}
                  size='small'
                  autoComplete='no'
                />
                <TextField
                  disabled={!editMode}
                  fullWidth
                  label='Description'
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                  size='small'
                  autoComplete='no'
                  multiline
                  minRows={3}
                />
              </Box>
              <Button
                disabled={!editMode || !transferDocumentId || loading}
                onClick={handleSave}
                type='submit'
                color='primary'
              >
                {loading ? 'Saving...' : 'Save'}
              </Button>
            </CardBody>
          </Card>
        </Grid>
        <Grid item xs={12} lg={9}>
          {documentDownloadUrl && attachments.length === 0 && (
            <Typography>
              Document Preview{' - '}
              <Typography component={Link} target={'_blank'} rel='noreferrer' href={documentDownloadUrl}>
                Click here to download
              </Typography>
            </Typography>
          )}
          {isForbidden ? (
            <Box textAlign='center' mt={5}>
              <Typography variant='h5' gutterBottom>
                Access Denied
              </Typography>
              <Typography variant='body1' gutterBottom>
                This document is not accessible from here. Please view it in the FWW Portal.
              </Typography>
              <Button
                color='info'
                onClick={() => {
                  const url = `https://admin.fwwportal.com/en/dashboard/transfers/details/${transferId}?tab=documents`;
                  window.open(url, '_blank', 'noopener,noreferrer');
                }}
              >
                view document in portal
              </Button>
            </Box>
          ) : (
            <Box boxShadow={2} style={{padding: '10px'}}>
              {documentDownloadUrl && attachments.length === 0 && (
                <Fragment>
                  <object data={documentDownloadUrl} width='100%' height={800}>
                    <Typography component={Link} target={'_blank'} href={documentDownloadUrl} rel='noreferrer'>
                      Click here to download
                    </Typography>
                  </object>
                </Fragment>
              )}
              {attachments && has_fww_portal_bucket === false ? (
                attachments.length > 0 ? (
                  <ul style={{paddingLeft: 16}}>
                    {attachments.map((item, index) => (
                      <li key={`attachment-${item}-${index}`}>
                        <AttachmentLink item={item} />
                      </li>
                    ))}
                  </ul>
                ) : null
              ) : (
                <Button
                  disabled={!transferDocumentId}
                  onClick={() => {
                    const url = `https://admin.fwwportal.com/en/dashboard/back-office/documents/transfer/details/${transferDocumentId}`;
                    window.open(url, '_blank', 'noopener,noreferrer');
                  }}
                  color='info'
                >
                  view document
                </Button>
              )}
            </Box>
          )}
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default TransferDocumentsView;
